import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';
import { InventoryItem, InventoryItemFeature } from '@contracts/interfaces/inventory-item.interface';
import { TemplateService } from '../../services/template.service';
import { SelectOpionServiceDialog } from '../../dialogs/select-option-dialog/select-option.service.dialog';
import { CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';
import { SPACE} from '@angular/cdk/keycodes';

@Component({
  selector: 'app-inventory-item-features',
  templateUrl: './item-features.component.html',
  styleUrls: ['./item-features.component.scss']
})
export class InventoryItemFeaturesComponent implements OnInit {

    @Input() 
    public item: InventoryItem;

    @Input() 
    public data: any;

    public featuresList: any[] = [];

    public allowAdditional = false;

    @ViewChild('select', { static: true }) select: any;

    constructor(
        private inventoryService: InventoryService,
        private cdr: ChangeDetectorRef,
        private templateService: TemplateService,
        private selectOpionServiceDialog: SelectOpionServiceDialog,
        ) { }

    ngOnInit(): void {

        if (this.data.allowAdditional != undefined) {
            this.allowAdditional = this.data.allowAdditional;
        }

        this.refresh();
    }

    refresh () {
        let newFeatureList = [];

        if (this.data.required != undefined) {
            newFeatureList.push(...this.data.required);
        }
        
        // Add on additional features
        for (let feature of this.item.features) {
            let doNotAdd = false;

            // Find if feature is in required
            for (let requiredFeature of this.data.required) {
                if (feature.label == requiredFeature.label) {
                    doNotAdd = true;
                }
            }

            if (!doNotAdd) {
                newFeatureList.push({
                    label: feature.label,
                    type: "custom",
                });    
            }
        }

        this.featuresList = newFeatureList;

        this.cdr.markForCheck();
    }

    addFeature() {
        if (this.item.features == undefined) {
            this.item.features = [];
        }

        this.featuresList.push({
            label: "",
            type: "custom"
        });
    }

    addFeatureMobile() {
        this.inventoryService.openItemFeatureDialog({
            label: ""
        }, "", (r: any) => {
            if (r != "delete" && r != undefined) {
                this.item.features.push({
                    label: r.itemFeature.label,
                    text: r.itemFeatureValue
                });

                this.refresh();
                this.save();
            }
        })
    }

    deleteFeature(featureLabel: string) {
        if (featureLabel == "") {
            this.refresh();
        }
        
        let index = null;

        for (let i=0; i < this.item.features.length; i++) {
            if (this.item.features[i].label == featureLabel) {
                index = i;
            }
        }

        if (index != null) {
            this.item.features.splice(index, 1);

            this.refresh();
            this.save();
        }
    }

    save() {
        this.item.lastModified = new Date();
        this.inventoryService.updateOne(this.item).subscribe(r => {

        });
    }

    getFeatureValue (featureLabel: string) {
        for (let feature of this.item.features) {
            if (feature.label == featureLabel) {
                return feature.text;
            }
        }

        return "";
    }

    saveFeatureText(featureLabel: string, featureText: string, $event: Event = null) {

        if (featureLabel == "") return;

        if (this.item.features == undefined) {
            this.item.features = [];
        }

        let found = false;
        for (let i=0; i < this.item.features.length; i++) {
            if (this.item.features[i].label == featureLabel) {
                this.item.features[i].text = featureText;
                found = true;
            }
        }

        if (!found) {
            this.item.features.push({
                label: featureLabel,
                text: featureText
            })
        }

        console.log("HIT");
        this.updateTitle();
    }

    saveCustomFeatureLabel(featureLabel: string, newFeatureLabel: string) {

        // Do nothing on empty
        if (newFeatureLabel == "") return;
        
        // Do nothing on no change
        if (featureLabel == newFeatureLabel) return;

        let index = null;
        for (let i=0; i < this.item.features.length; i++) {
            if (this.item.features[i].label == newFeatureLabel) {
                index = i;
            }
        }

        // Prevent updating to an existing one
        if (index != null) {
            this.refresh();
            return;
        }

        // This is a new feature
        if (featureLabel == "") {
            // Ensure it will be unique
            if (index == null) {
                this.item.features.push({
                    label: newFeatureLabel,
                    text: ""
                });
            }
        } else {
            index = null;
            // Find existing one
            for (let i=0; i < this.item.features.length; i++) {
                if (this.item.features[i].label == featureLabel) {
                    index = i;
                }
            }
            
            if (index != null) {
                this.item.features[index].label = newFeatureLabel;
            }
        }

        this.save();
    }

    updateTitle() {

        if (this.data.title == "" || this.data.title == undefined) {
            this.save();
            return;
        }

        this.templateService.render(this.data.title, this.item).subscribe((r: any) => {
            this.item.title = r.render;
            this.checkTitleLength(this.item.title);
            this.save();

            console.log(this.item.title)
        });
    }

    isTitleDynamic() {
        if (this.data.title == "") {
            return false;
        }
        
        return true;
    }

    public titleClassForSize: string = "large";
    checkTitleLength(title: string) {
      if (title.length < 50) { 
        this.titleClassForSize = "larger";    
      } else if (title.length < 63) {
        this.titleClassForSize = "large";
      } else if (title.length < 75) {
        this.titleClassForSize = "medium";
      } else if (title.length < 80) {
        this.titleClassForSize = "small";
      }
    }

    editFeature(itemFeature: InventoryItemFeature) {
        let val = this.getFeatureValue(itemFeature.label);
        this.inventoryService.openItemFeatureDialog(itemFeature, val, (r: any) => {

            if (r == "delete") {
                this.deleteFeature(itemFeature.label);
            } else if (r != undefined) {
                this.saveCustomFeatureLabel(itemFeature.label, r.itemFeature.label);
                this.saveFeatureText(r.itemFeature.label, r.itemFeatureValue);
            }
        });
    }

    openFeatureSelectDialog(feature: string, current: string, options: string[]) {
        this.selectOpionServiceDialog.open(feature, current, options, ((val:string)=> {
            if (val != undefined) {
                this.saveFeatureText(feature, val);
            }
        }))
    }
}